<template>
  <div :class="['widget-common', 'widget-full-height', sizeClass]">
    <div class="widget-title">
      <div class="d-flex align-items-baseline">
        {{ label }}
        <i
          v-tooltip="tooltipOptions"
          class="hi hi-info-filled ml-5"
          :title="titleTooltip"
        ></i>
      </div>
    </div>

    <div class="widget-body">
      <div class="activity-information d-flex justify-content-between">
        <div class="d-flex flex-column justify-content-between">
          <div class="score">
            <div class="percentage">{{ score }}%</div>
            <div class="score-label">Average</div>
          </div>
          <AppChartLegend
            :values="chartRanges"
            :include-values="false"
            orientation="vertical"
          ></AppChartLegend>
        </div>
        <div class="chart d-flex align-items-end">
          <div class="legend d-flex flex-column-reverse justify-content-between align-items-end">
            <div
              v-for="(value, key) in legendValues"
              :key="key"
              class="value"
            >
              <span>{{ value }}%</span>
            </div>
          </div>
          <div class="meter">
            <div
              v-for="(item, key) in chartRanges"
              :key="key"
              v-tooltip="tooltipOptions"
              class="section"
              :class="`activity-${item.key}`"
              :title="item.tooltip"
            ></div>
            <div
              class="bar"
              :style="setBarHeight(score)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="widget-footer-bordered">
      <InsightsBenchmarksAverages
        :averages="benchmarksAverages"
        :is-loading="false"
        :pins="benchmarkPins"
        :widget-name="title"
      />
    </div>
  </div>
</template>

<script>
import AppChartLegend from '~/components/AppChartLegend.vue';
import InsightsBenchmarksAverages from '~/components/insights/InsightsBenchmarksAverages.vue';
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'ActivityLevelWidget',
  components: { AppChartLegend, InsightsBenchmarksAverages },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    widgetData: null,
    widgetKey: INSIGHTS.api.highlights.activity,
    tooltipOptions: Object.freeze({
      placement: 'top',
      html: true,
      template:
        '<div class="vue-tooltip top insights-activity-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    }),
    titleTooltip: 'Average mouse & keyboard activity by range',
    label: 'ACTIVITY',
    ranges: INSIGHTS.acitivity_ranges,
    legendValues: [0, 25, 50, 75, 100],
    title: 'Activity',
    sizeClass: 'widget-medium',
  }),
  computed: {
    score() {
      return this.activity?.score;
    },
    benchmarksAverages() {
      return this.activity?.benchmarks;
    },
    benchmarkPins() {
      return [{ key: 'standard', value: this.score }];
    },
    chart() {
      return this.widgetData?.chart
        ? Object.keys(this.widgetData.chart)
            .filter(
              (key) =>
                this.widgetData.chart[key] &&
                this.widgetData.chart[key].tracked > 0 &&
                this.widgetData.chart[key].value > 0,
            )
            .reduce(
              (acc, key) => ({
                ...acc,
                [key]: {
                  // eslint-disable-next-line no-undef
                  tracked: formatDuration(this.widgetData.chart[key].tracked, { showSeconds: 'never' }),
                  value: this.widgetData.chart[key].value * 100,
                },
              }),
              {},
            )
        : [];
    },
    chartRanges() {
      return Object.entries(this.ranges).map(([key, value]) => ({
        ...value,
        tooltip: this.chart[key] ? `${this.buildTooltip(this.chart[key])} ${value.tooltip}` : '',
      }));
    },
  },
  beforeMount() {
    this.$store = { state: { filters: {}, num_active_smart_notifs: 0 } };
  },
  methods: {
    setBarHeight(value) {
      const height = value > 100 ? 100 : value;

      return `height: ${height}%`;
    },
    buildTooltip(item) {
      const [hours, minutes] = item.tracked.split(':');

      return `${hours}h ${minutes}m spent in`;
    },
  },
};
</script>
